module.exports = __webpack_public_path__ + "img/spyder-token.d9d8c5df.png";